import { Divider, Form, Typography } from 'antd';
import type { FormItemProps } from 'antd/lib/form';
import { createUseStyles } from 'react-jss';
import { shipiumTheme as theme } from '@shipium-corp/shipium-ui-theme';

const { Title, Text } = Typography;

const useStyles = createUseStyles({
  root: {
    padding: 24,
  },
  header: {
    marginBottom: 20,
  },
  tag: {
    fontSize: 13,
    fontWeight: 400,
    marginLeft: 8,
  },
  divider: {
    margin: '4px 0 16px',
  },
  sectionLabel: {
    display: 'block',
    marginBottom: 8,
    fontSize: 12,
    textTransform: 'uppercase',
    letterSpacing: 0.5,
    color: theme.token.colorPrimary,
  },
});

export const CompactFormItem = (props: FormItemProps) => (
  <Form.Item {...props} style={{ marginBottom: 12, ...props.style }} />
);

interface StepLayoutProps {
  title: string;
  description: string;
  tag?: string;
  children: React.ReactNode;
}

export const StepLayout = ({ title, description, tag, children }: StepLayoutProps) => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <div className={classes.header}>
        <Title level={4} style={{ margin: 0 }}>
          {title}
          {tag && (
            <Text type="secondary" className={classes.tag}>
              {tag}
            </Text>
          )}
        </Title>
        <Text type="secondary">{description}</Text>
      </div>
      {children}
    </div>
  );
};

interface SectionLabelProps {
  label: string;
  noDivider?: boolean;
}

export const SectionLabel = ({ label, noDivider = false }: SectionLabelProps) => {
  const classes = useStyles();
  return (
    <>
      {!noDivider && <Divider className={classes.divider} />}
      <Text strong className={classes.sectionLabel}>
        {label}
      </Text>
    </>
  );
};
